const DEFAULT_DESCRIPTION =
  'Alquila salas y espacios por horas para fiestas, eventos y celebraciones. Reserva segura con pago online y propietarios verificados.';

const SITE_NAME = 'TimeFlexRent';

export function truncateSeoText(text: string, max = 160): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, max - 1).trimEnd()}…`;
}

export function buildSpaceSeoTitle(spaceName: string, location?: string): string {
  const name = spaceName.trim() || 'Espacio';
  if (location?.trim()) {
    return `${name} · alquiler por horas en ${location.trim()} | ${SITE_NAME}`;
  }
  return `${name} · alquiler por horas | ${SITE_NAME}`;
}

export function buildSpaceSeoDescription(
  spaceName: string,
  description: string,
  location?: string,
): string {
  const fromBody = truncateSeoText(description, 155);
  if (fromBody.length >= 40) return fromBody;
  const name = spaceName.trim() || 'este espacio';
  const where = location?.trim() ? ` en ${location.trim()}` : '';
  return truncateSeoText(
    `Reserva ${name}${where} por horas en TimeFlexRent. Consulta disponibilidad, precios y reserva online.`,
  );
}

export function buildExploreSeoTitle(provinceLabel?: string): string {
  if (provinceLabel?.trim()) {
    return `Espacios para alquilar en ${provinceLabel.trim()} | ${SITE_NAME}`;
  }
  return `Explorar espacios para alquilar por horas | ${SITE_NAME}`;
}

export const SEO_DEFAULTS = {
  siteName: SITE_NAME,
  defaultTitle: SITE_NAME,
  defaultDescription: DEFAULT_DESCRIPTION,
} as const;
